// extracted by mini-css-extract-plugin
export default {"wrapper":"style-module--wrapper--c57b3"};